import classNames from "classnames";
import styles from "./ToggleGroup.module.scss";
import Button, { ButtonProps } from "../Button/Button";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";

function ToggleGroup({
  selectedItem,
  setSelectedItem,
  className,
  items,
  size,
}: {
  selectedItem: string;
  setSelectedItem: (value: string) => void;
  className?: string;
  items: { id: string; name: React.ReactNode }[];
  size?: ButtonProps["size"];
}) {
  return (
    <ToggleGroupPrimitive.Root
      type="single"
      className={classNames(styles.container, className)}
      value={selectedItem}
      onValueChange={setSelectedItem}
    >
      {items.map((item) => (
        <ToggleGroupPrimitive.Item key={item.id} asChild value={item.id}>
          <Button
            size={size}
            variant="outline"
            className={classNames({
              [styles.selected]: selectedItem === item.id,
            })}
          >
            {item.name}
          </Button>
        </ToggleGroupPrimitive.Item>
      ))}
    </ToggleGroupPrimitive.Root>
  );
}

export default ToggleGroup;
